'use es6';

import enviro from 'enviro';
var HUBLET_SUFFIX = enviro.getHublet() === 'na1' ? '' : "-" + enviro.getHublet();
var QA_SUFFIX = window.location.href.indexOf('hubspotqa.com') !== -1 ? 'qa' : '';
var IS_LOCAL = window.location.href.indexOf('://local.hubspot') !== -1;
var IS_API_LOCAL = window.localStorage && window.localStorage.HOME_API_ENV === 'local';
var APP_ROOT_PATH = "https://app" + HUBLET_SUFFIX + ".hubspot" + QA_SUFFIX + ".com";
var LOCAL_APP_ROOT_PATH = "https://local" + HUBLET_SUFFIX + ".hubspot" + QA_SUFFIX + ".com";
var API_ROOT_PATH = "https://api" + HUBLET_SUFFIX + ".hubspot" + QA_SUFFIX + ".com";
var LOCAL_API_ROOT_PATH = "https://local" + HUBLET_SUFFIX + ".hubspot" + QA_SUFFIX + ".com";
export var api = function api(path) {
  var root = IS_API_LOCAL ? LOCAL_API_ROOT_PATH : API_ROOT_PATH;
  return "" + root + path;
};
export var contactSupport = function contactSupport() {
  return 'mailto:support@hubspot.com';
};
export var error = function error() {
  var root = IS_LOCAL ? LOCAL_APP_ROOT_PATH : APP_ROOT_PATH;
  return root + "/home-beta/error" + window.location.search;
};
export var profileAndPreferences = function profileAndPreferences(portalId) {
  return APP_ROOT_PATH + "/user-preferences/" + portalId;
};
export var login = function login(portalId) {
  if (!portalId) {
    return APP_ROOT_PATH + "/login";
  }

  return APP_ROOT_PATH + "/login?loginPortalId=" + portalId;
};